import React from 'react';
import PropTypes from 'prop-types';

const Leaf = ({ attributes, children, leaf }) => {
	let content = children;
	if (leaf.bold) {
		content = <strong>{content}</strong>;
	}

	if (leaf.code) {
		content = <code>{content}</code>;
	}

	if (leaf.italic) {
		content = <em>{content}</em>;
	}

	if (leaf.underlined) {
		content = <u>{content}</u>;
	}

	if (leaf.strikethrough) {
		content = <del>{content}</del>;
	}

	// eslint-disable-next-line react/jsx-props-no-spreading
	return <span {...attributes}>{content}</span>;
};

Leaf.propTypes = {
	attributes: PropTypes.object,
	children: PropTypes.string,
	leaf: PropTypes.shape({
		bold: PropTypes.bool,
		code: PropTypes.bool,
		italic: PropTypes.bool,
		underlined: PropTypes.bool,
		strikethrough: PropTypes.bool
	})
};

export default Leaf;
